import React from 'react';


export const TinyLetterForm = (props) => {
  const children = React.Children.map(
    props.children,
    child => child.props.type === 'email' ?
      React.cloneElement(child, {
        name: 'email',
        required: true
      }) :
      child
  );

  const subscribe = () => {
    window.open(
      `https://tinyletter.com/${props.list}`,
      'popupwindow',
      'scrollbars=yes,width=800,height=600'
    );

    return true;
  };

  return (
    <form
      action={`https://tinyletter.com/${props.list}`}
      method="post"
      target="popupwindow"
      onSubmit={subscribe}
      {...props}
      >
      <input type="hidden" value="1" name="embed" />
      {children}
    </form>
  );
};



// WEBPACK FOOTER //
// ./src/components/forms/TinyLetterForm.js